export default __webpack_public_path__ + "static/media/Events.e8a05f6b.svg";